import { Grid, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import filllog from '../Asset/bg/master-footer-logo.png'
const FooterPage = () => {
  return (
    <Grid container sx={{textAlign:'center',padding:'20px',paddingTop:'40px'}}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <img src={filllog} alt="Logo" height={'65px'} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display:'flex',justifyContent:'center',alignItems:'center',margin:'3%',paddingRight:'1%',paddingTop:'2%'}}>
            <Typography centered={"true"} sx={{width:'65%',fontFamily:'Inter',fontWeight:300,fontSize:'10pt'}}>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying.</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Grid container sx={{display:'flex',justifyContent:'center',alignItems:'center',marginTop:'10px'}}>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                    <Typography sx={{color:'#2f6df6',textDecoration:'none',fontFamily:'Inter'}} component={Link} to='/'>Home</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} sx={{borderLeft:'1px solid gray'}}>
                    <Typography sx={{color:'#2f6df6', textDecoration:'none',fontFamily:'Inter'}} component={Link} to='/launchpad'>Launchpad</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1} sx={{borderLeft:'1px solid gray'}}>
                    <Typography sx={{color:'#2f6df6', textDecoration:'none',fontFamily:'Inter'}} component={Link} to='/games'>Games</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1} sx={{borderLeft:'1px solid gray'}}>
                    <Typography sx={{color:'#2f6df6', textDecoration:'none',fontFamily:'Inter'}} component={Link} to='/guilds'>Guilds</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} sx={{borderLeft:'1px solid gray'}}>
                    <Typography sx={{color:'#2f6df6',textDecoration:'none',fontFamily:'Inter'}} component={Link} to='/leaderboard'>Leaderboard</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1} sx={{borderLeft:'1px solid gray'}}>
                    <Typography sx={{color:'#2f6df6', textDecoration:'none',fontFamily:'Inter'}} component={Link} to='/staking'>Staking</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1} sx={{borderLeft:'1px solid gray'}}>
                    <Typography sx={{color:'#2f6df6', textDecoration:'none',fontFamily:'Inter'}} component={Link} to='/tiers'>Tiers</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1} lg={1} xl={1} sx={{borderLeft:'1px solid gray'}}>
                    <Typography sx={{color:'#2f6df6', textDecoration:'none',fontFamily:'Inter'}} component={Link} to='/info'>Info</Typography>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Grid container sx={{display:'flex',justifyContent:'center',alignItems:'center',marginTop:'10px'}}>
                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5}>
                    <Typography sx={{color:'gray',fontFamily:'Inter',fontSize:'10pt'}}>Whitepaper</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1.1} lg={1.1} xl={1.1}>
                    <Typography sx={{color:'gray', borderLeft:'1px solid gray',fontFamily:'Inter',fontSize:'10pt'}}>Pitchdeck</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <Typography sx={{color:'gray', borderLeft:'1px solid gray',fontFamily:'Inter',fontSize:'10pt'}}>Terms & Condition</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5}>
                    <Typography sx={{color:'gray', borderLeft:'1px solid gray',fontFamily:'Inter',fontSize:'10pt'}}>Privacy Policy</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <Typography sx={{color:'gray', borderLeft:'1px solid gray',fontFamily:'Inter',fontSize:'10pt'}}>Apply for Launch</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5}>
                    <Typography sx={{color:'gray', borderLeft:'1px solid gray',fontFamily:'Inter',fontSize:'10pt'}}>Game Listing</Typography>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Grid container sx={{display:'flex',justifyContent:'center',alignItems:'center',marginTop:'10px'}}>
                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                    <Typography sx={{color:'gray',fontFamily:'Inter',fontSize:'10pt'}}>Guild Listing Careers</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                    <Typography sx={{color:'gray', borderLeft:'1px solid gray',fontFamily:'Inter',fontSize:'10pt'}}>Ambassador Program</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5}>
                    <Typography sx={{color:'gray', borderLeft:'1px solid gray',fontFamily:'Inter',fontSize:'10pt'}}>Influencers</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <Typography sx={{color:'gray', borderLeft:'1px solid gray',fontFamily:'Inter',fontSize:'10pt'}}>Affiliate Program</Typography>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display:'flex',justifyContent:'center',alignItems:'center',margin:'3%',paddingTop:'2%'}}>
            <Typography variant='caption'sx={{color:'gray',fontFamily:'Inter',fontSize:'8pt'}} >&copy; 2022 SolaDefy. All Rights Reserved.</Typography>
        </Grid>
    </Grid>
  );
};

export default FooterPage;